/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import qs from "qs";
import UploadZip from "../uploadDocument/UploadFileZip";
import {
  fetchAuctionRequest,
  fetchGradeRequest,
  fetchMarkRequest,
  getAllCategoriesAction,
  getAllTeaTypes,
  getBuyer,
  getAllTaxInvoiceActionSuccess,
  getGstExcelByIdAction,
  fetchUser,
  getExportDataSeller,
  getAllTaxInvoiceBuyerAction,
  getAllTaxInvoiceGenAction,
  getAllTaxInvoiceSaleAction,
  getAllTaxInvoiceLotAction,
  getAllSellerTaxInvoiceSessionAction,
  getAllSellerTaxAction,
  getSellerTaxGenByIdAction,
  getAuctiondataAction,
  getAllSellerTaxGenBuyerAction,
  getChargeTaxByIdAction,
  getAllSubmitChargeAction,
  getSubmitAllAddChargeAction,
  getExportData,
  getExportDataApiCall,
  getAllSellerTaxGenSaleGenAction,
  getAllSellerTaxGenActionSuccess,
  getAllTaxInvoiceSessionAction,
  getExportDataSellerApiCall,
} from "../../store/actions";
import { useSelector } from "react-redux";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";
import Checkbox from "@mui/material/Checkbox";
import TableComponent from "../../components/tableComponent/TableComponent";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axiosMain from "../../http/axios/axios_main";
import CustomToast from "../../components/Toast";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { Card, Form, Modal, Button } from "react-bootstrap";
import moment from "moment";
import Base64ToExcelDownload from "../Base64ToExcelDownload";
import { uploadedFileDownload } from "../uploadDocument/UploadedFileDownload";
import { NO_OF_RECORDS } from "../../constants/commonConstants";
import { useAuctionDetail } from "../../components/common/AunctioneerDeteailProvider";

let pageNo = 1;
function SellerTaxInvoice({
  modalRight,
  onFileSelect,
  inputId,
  open,
  setOpen,
}) {
  const seasonYear = moment().year();
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= 6; i++) {
    const year = currentYear - i;
    years.push(year);
  }
  const tableRef = useRef(null);
  const [catshowmodal, setcatshowmodal] = useState(false);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(false);
  const handleViewClick = (e) => {
    searchData(e)
    setShowmodal(false)
  };
  const { auctionDetailId, auctionCenterUserId, auctionCenterId, userId } =
    useAuctionDetail();
  const [totCharge, settotCharge] = useState(0);
  const [grossTeaValue, setGrossTeaValue] = useState(0);
  const [tboardToSellerInvoiceAmount, setTboardToSellerInvoiceAmount] = useState(0);
  const [auctioneerToSellerInvoiceAmount, setAuctioneerToSellerInvoiceAmount] = useState(0);
  const [netAmount, setnetAmount] = useState(0);
  const [total, settotal] = useState(0);
  const [grossTea, setgrossTea] = useState(0);
  const [totalSftp, settotSftp] = useState(0);
  const [pils, setpils] = useState("0.00");
  const [sellerChestageAllowance, setsellerChestageAllowance] =
    useState("0.00");
  const [sptfRecovery, setsptfRecovery] = useState("0.00");
  const [damageClaims, setdamageClaims] = useState("0.00");
  const [withdrawnCharges, setwithdrawnCharges] = useState("0.00");
  const [withdrawnSGST, setwithdrawnSGST] = useState("");
  const [withdrawnCGST, setwithdrawnCGST] = useState("");
  const [withdrawnIGST, setwithdrawnIGST] = useState("");
  const [freightCharges, setfreightCharges] = useState("0.00");
  const [invoiceDeatilsId, setinvoiceDeatilsId] = useState("");
  const [invoiceId, setinvoiceId] = useState("");
  const [markId, setMarkId] = useState("");
  const [sstatus, setStatus] = useState("");
  const [goodsInvoicesChargesStatus, setgoodsInvoicesChargesStatus] = useState("");
  const [goodsInvoiceReferenceNo, setgoodsInvoiceReferenceNo] = useState("");
  const [remarks, setremarks] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [viewMode, setViewMode] = useState(false);
  const [categoryError, setCategoryError] = useState("");
  const handlecatId = () => setcatshowmodal(false);
  const [showmodal, setShowmodal] = useState(false);
  const [mode, setMode] = useState('');
  const [showmodalCharge, setShowmodalCharge] = useState(false);
  const [showViewModalCharge, setShowViewModalCharge] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [allTeaTypeList, setallTeaTypeList] = useState([]);
  const [editingCharge, seteditingCharge] = useState({});
  const [allGrade, setallGrade] = useState([]);
  const [allMarkList, setallMarkList] = useState([]);
  const [allAuctionCenterList, setallAuctionCenterList] = useState([]);
  const [allCategory, setallCategory] = useState([]);
  const [season, setSeason] = useState(currentYear);
  const [allBuyer, setallBuyer] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isSingleSelected, setisSingleSelected] = useState(false);

  const [isAllChargeButtonDisabled, setIsAllChargeButtonDisabled] = useState(false);
  const [confirmationModalVisible, setConfirmationModalVisible] =
    useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [uploadDocumentError, setUploadDocumentError] = useState("");
  const [exportTypes, setexportTypes] = useState("");
  const [exportType, setexportType] = useState("");
  const [exportViewType, setexportViewType] = useState("");
  const dispatch = useDispatch();
  const [invoieceGenerateList, setinvoieceGenerateList] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const [TaxInvoiceSearch, setTaxInvoiceSearch] = useState({
    season: season + "",
    saleNo: null,
    roleCode: "AUCTIONEER",
    userId: atob(sessionStorage.getItem("argument2")),
    einvoiceEligibility: null,
    status: null,
    mark: null,
    seller: null,
    bilingType: null,
  });

  const Validate = () => {
    let isValid = true;
    if (
      TaxInvoiceSearch.season == null ||
      TaxInvoiceSearch.season == "SELECT" ||
      TaxInvoiceSearch.season == undefined
    ) {
      CustomToast.error("Please select season");
      isValid = false;
      return;
    }
    if (!TaxInvoiceSearch.saleNo) {
      CustomToast.error("Please select sale no");
      isValid = false;
    }

    if (TaxInvoiceSearch.einvoiceEligibility == "") {
      TaxInvoiceSearch.einvoiceEligibility = null;
    }
    if (TaxInvoiceSearch.mark == "") {
      TaxInvoiceSearch.mark = null;
    }
    if (TaxInvoiceSearch.Seller == "") {
      TaxInvoiceSearch.Seller = null;
    }
    // if (TaxInvoiceSearch.bilingType == "") {
    //   TaxInvoiceSearch.bilingType = null;
    // }
    if (TaxInvoiceSearch.status == "") {
      TaxInvoiceSearch.status = null;
    }

    return isValid;
  };

  const allTeaType = useSelector(
    (state) => state?.teaTypeManage?.allTeaTypes?.responseData
  );
  const getAllAuctionCenterList = useSelector(
    (res) => res?.warehouseUserRegistration?.auctionCenter?.responseData
  );
  const markList = useSelector((state) => state.mark.data.responseData);

  const allActiveCategory = useSelector(
    (state) => state?.categoryManage?.allCategories?.responseData
  );
  const grades = useSelector((state) => state.grade.data.responseData);

  const invoieceGenerateListData = useSelector(
    (state) => state?.SellerTaxgen?.SellerTaxGenById?.responseData
  );

  const isSubmitChargeApiCalling = useSelector(
    (state) => state?.SellerTaxgen?.loading
  )
  const isDownloading = useSelector(
    (state) => state?.SellerTaxgen?.downloading
  );

  const BuyerList = useSelector(
    (state) => state?.BuyerTaxInvoice?.getAllTaxInvoiceBuyer?.responseData
  );

  let getAllTaxInvoiceResponse = useSelector(
    (state) => state?.SellerTaxgen?.getAllSellerTaxGen?.responseData
  );

  let getAllTaxAll = useSelector(
    (state) => state?.SellerTaxgen?.ApiStatusSeller
  );
  useEffect(() => {
    if (true == getAllTaxAll) {
      setTimeout(() => {
        setLoader(false);
        pageNo = pageNo;
      }, 1000);
    }
  });
  const listbyinvoice = useSelector(
    (state) => state?.SellerTaxgen?.getAllSellerTaxGenSale?.responseData
  );

  const AddchargeId = useSelector(
    (state) => state?.SellerTaxgen?.ChargeById?.responseData
  );

  useEffect(() => {
    if (AddchargeId) {
      seteditingCharge(AddchargeId);
      setpils(AddchargeId.pils || "");
      setsellerChestageAllowance(AddchargeId.sellerChestageAllowance || "");
      setsptfRecovery(AddchargeId.sptfRecovery || "0");
      
      setdamageClaims(AddchargeId.damageClaims || "");
      setwithdrawnCharges(AddchargeId.withdrawnCharges || "");
      setwithdrawnSGST(AddchargeId.withdrawnSGST || "");
      setwithdrawnCGST(AddchargeId.withdrawnCGST || "");
      setwithdrawnIGST(AddchargeId.withdrawnIGST || "0");
      setfreightCharges(AddchargeId.freightCharges || "");
      setremarks(AddchargeId.remarks || "");
    }
  }, [AddchargeId]);

  useEffect(() => {
    // if(withdrawnCharges) {
    const withdrawnCharges = parseFloat(editingCharge?.withdrawnCharges) || 0;
    const preGstAmount = parseFloat((withdrawnCharges / 118) * 100).toFixed(2);
    const totalGst = withdrawnCharges - preGstAmount;
    const halfGst = (totalGst / 2).toFixed(2);
    seteditingCharge({
      ...editingCharge,
      withdrawnSGST: halfGst || 0,
      withdrawnCGST: halfGst || 0
    })
    // }
    
  }, [withdrawnCharges, editingCharge?.withdrawnCharges])

  useEffect(() => {

    if (rows) {
      const isSubmitAllChargeButtonDisable = rows.some(item => item.status === "2")
      setIsAllChargeButtonDisabled(isSubmitAllChargeButtonDisable)
    }
  }, [rows])

  useEffect(() => {
    if (!isSubmitChargeApiCalling && TaxInvoiceSearch.saleNo) {
      fetchData();
    }
  }, [isSubmitChargeApiCalling])

  const auctionlist = useSelector(
    (state) => state?.SellerTaxgen?.getAllAuctiondata?.responseData
  );
  const getExportDataSellerResponse = useSelector(
    (state) => state.BuyerTaxInvoice.exportDataSeller.responseData
  );

  const getExportDataSellerApiCallResponse = useSelector(
    (state) => state.BuyerTaxInvoice.exportDataSellerApiCall
  );
  // useEffect(() => {
  //   if (
  //     getExportDataSellerResponse != null &&
  //     true == getExportDataSellerApiCallResponse
  //   ) {
  //     dispatch(getExportDataSellerApiCall(false));
  //     // if ("excel" == exportType) {
  //     Base64ToExcelDownload(
  //       getExportDataSellerResponse,
  //       "SellerTaxInvoiceDetails.xlsx"
  //     );
  //   }
  // });

  useEffect(() => {
    if (
      getExportDataSellerResponse != null &&
      getExportDataSellerApiCallResponse === true
    ) {
      dispatch(getExportDataSellerApiCall(false));
      getExportDataSellerResponse.map((base64String, index) => {
        const filename = `SellerTaxInvoiceDetails_${index + 1}.xlsx`;
        Base64ToExcelDownload(base64String, filename);
      });
    }
  }, [getExportDataSellerResponse, getExportDataSellerApiCallResponse]);

  const SearchViewDealBook = (e) => {
    e.preventDefault();
    if (Validate()) {
      setLoader(true);
      getAllSellerTaxAction({ pageNo: 1, noOfRecords: NO_OF_RECORDS });
    }
  };

  const confirmInvoiceGeneration = () => {
    setConfirmationModalVisible(true);
  };
  const handleConfirm = (confirmed, invoicedetailid) => {
    let data = {
      invoiceDetailId: invoicedetailid
    }
    dispatch(getSellerTaxGenByIdAction(data));
    setinvoiceDeatilsId(invoicedetailid);
    if (confirmed) {
      let selectedBuyer = [];
      getAllTaxInvoiceResponse &&
        getAllTaxInvoiceResponse.map(
          (viewTaxInvoiceData, viewTaxInvoiceDataIndex) => {
            if (
              viewTaxInvoiceData &&
              viewTaxInvoiceData.isSelected &&
              true == viewTaxInvoiceData.isSelected
            ) {
              let tempJSON = {
                listInvoiceDeatilsId: viewTaxInvoiceData.invoicedetailid,
              };
              selectedBuyer.push(tempJSON);
            }
          }
        );
      if (selectedBuyer && selectedBuyer.length == 0) {
        toast.error("Please select atleast one data to generate invoice");
        return;
      }
      dispatch(getAllSellerTaxGenSaleGenAction(selectedBuyer));
      // toast.success("Invoice generation successful");
      setcatshowmodal(false);
      setConfirmationModalVisible(false);
      setIsAllSelected(false);
      setisSingleSelected(false);
      dispatch(getAllSellerTaxGenActionSuccess([]));
    } else {
      setConfirmationModalVisible(false);
      setisSingleSelected(false);
      setIsAllSelected(false);
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    if (Validate()) {
      setLoader(true);
      fetchData();
      setRows([]);
    }
  };
  const handleFileUpload = (files) => {
    const newFiles = files?.map((file) => ({
      base64: file.documentContent,
      filename: file.documentName,
      invoiceno: file.invoiceNo,
      userId: atob(sessionStorage.getItem("argument2")),
    }));
    setUploadedDocuments(newFiles);
  };
  const fetchData = () => {
    dispatch(
      getAllSellerTaxAction({
        season: TaxInvoiceSearch.season,
        saleNo: TaxInvoiceSearch.saleNo,
        roleCode: "AUCTIONEER",
        userId: atob(sessionStorage.getItem("argument2")),
        einvoiceEligibility: TaxInvoiceSearch.einvoiceEligibility,
        status: null,
        mark: TaxInvoiceSearch.mark,
        seller: TaxInvoiceSearch.Seller,
        bilingType: TaxInvoiceSearch.bilingType || 1 + "",
        pageNo: 1,
        noOfRecords: NO_OF_RECORDS,
      })
    );
  };
  const handleViewMore = () => {
    setIsDisabled(true);
    pageNo = pageNo + 1;
    dispatch(
      getAllSellerTaxAction({
        season: TaxInvoiceSearch.season,
        saleNo: TaxInvoiceSearch.saleNo,
        roleCode: "AUCTIONEER",
        userId: atob(sessionStorage.getItem("argument2")),
        einvoiceEligibility: TaxInvoiceSearch.einvoiceEligibility,
        status: null,
        mark: TaxInvoiceSearch.mark,
        seller: TaxInvoiceSearch.Seller,
        bilingType: TaxInvoiceSearch.bilingType || 1 + "",
        pageNo: pageNo,
        noOfRecords: NO_OF_RECORDS,
      })
    );
  };
  const ResetViewBook = (e) => {
    e.preventDefault();
    setTaxInvoiceSearch({
      season: seasonYear,
      saleNo: "",
      roleCode: null,
      userId: null,
      einvoiceEligibility: "",
      status: "",
      mark: "",
      Seller: "",
      bilingType: "",
    });
    pageNo = 1;
    setRows([]);
    setIsAllSelected(false);
    getAllSellerTaxAction({ pageNo: 1, noOfRecords: NO_OF_RECORDS });
    dispatch(getAllSellerTaxGenActionSuccess([]));
  };
  const handleViewDealSearch = (e) => {
    const { name, value } = e.target;
    const seasonValue = name === "season" ? String(value) : value;
    setTaxInvoiceSearch((prevTaxInvoiceSearch) => ({
      ...prevTaxInvoiceSearch,
      [name]: seasonValue,
    }));
    setSeason(seasonValue);
    if ("auctionCentre" == null && "auctionCentre" == "") {
      setTaxInvoiceSearch((prevTaxInvoiceSearch) => ({
        ...prevTaxInvoiceSearch,
        season: "",
        saleNo: null,
      }));
    }
    if ("auctionCentre" == name && value != "") {
      dispatch(
        getAllTaxInvoiceSessionAction({
          season: TaxInvoiceSearch.season,
          saleNo: TaxInvoiceSearch.saleNo,
          auctionDate: value,
          // auctionCenterId: TaxInvoiceSearch.auctionCenterId,
          auctionCenterId: atob(window.location.pathname.split("/")[4]),
        })
      );

      setTaxInvoiceSearch((prevTaxInvoiceSearch) => ({
        ...prevTaxInvoiceSearch,
        season: seasonYear + "",
        saleNo: null,
      }));

      dispatch(
        getAllTaxInvoiceBuyerAction({
          season: seasonYear + "",
          auctionCenterId: atob(window.location.pathname.split("/")[4]),
        })
      );
    }

    if ("season" == name && value != "") {
      dispatch(
        getAllTaxInvoiceBuyerAction({
          season: seasonValue,
          auctionCenterId: atob(window.location.pathname.split("/")[4]),
        })
      );
      setTaxInvoiceSearch((prevTaxInvoiceSearch) => ({
        ...prevTaxInvoiceSearch,
        saleNo: null,
      }));
    }

    if ("saleNo" == name && value != "") {
      dispatch(
        getAllTaxInvoiceSaleAction({
          season: TaxInvoiceSearch.season,
          saleNo: value,
          auctionCenterId: atob(window.location.pathname.split("/")[4]),
        })
      );

      // dispatch(
      //   getAllTaxInvoiceLotAction({
      //     season: TaxInvoiceSearch.season,
      //     saleNo: value,
      //     auctionCenterId: TaxInvoiceSearch.auctionCentre,
      //   })
      // );
    }
    if ("auctionDate" == name && value != null) {
      dispatch(
        getAllTaxInvoiceSessionAction({
          season: TaxInvoiceSearch.season,
          saleNo: TaxInvoiceSearch.saleNo,
          auctionDate: value,
          auctionCenterId: atob(window.location.pathname.split("/")[4]),
        })
      );
    }
  };
  const handleCloseModal = () => {
    const inputElement = document.getElementById("individualTaxInvoice");
    if (inputElement) {
      inputElement.value = "";
    }
    setModalOpen(false);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "2":
        return "status-green";
      case "1":
        return "status-orange";
      default:
        return "status-pink";
    }
  };


  const getStatusData = (status) => {
    switch (status) {
      case "1":
        return "Charges Saved";
      case "2":
        return "Charges Submitted";
      default:
        return "Charges not Submitted";
    }
  }
  const handleExport = (exportType) => {
    setexportType("");
    let searchData = {
      season: seasonYear,
      saleNo: TaxInvoiceSearch.saleNo,
      roleCode: "AUCTIONEER",
      userId: atob(sessionStorage.getItem("argument2")),
      einvoiceEligibility: TaxInvoiceSearch.einvoiceEligibility,
      status: null,
      mark: TaxInvoiceSearch.mark,
      seller: TaxInvoiceSearch.Seller,
      bilingType: TaxInvoiceSearch.bilingType || 1 + "",
      url: "/postauction/sellertaxinvoice/search",
      exportType: exportType,
      isExport: 1,
    };
    setexportType(exportType);
    dispatch(getExportData(searchData));
  };

  const handleSubmitAllCharge = () => {

    let payloadData = {
      submitChargeDataDtos: rows.map(item => ({
        invoiceId: item.goodsInvoiceId || "",
        markId: item.markId?.toString() || "",
        goodsGrandTotal: parseFloat(item.teaTotalInvoiceAmount) || 0,
        serviceGrandTotalAToS: parseFloat(item.auctioneerTotalInvoiceAmount) || 0,
        serviceGrandTotalTToS: parseFloat(item.teaBoardInvoiceAmount) || 0,
        atosinvoiceid: parseFloat(item.goodsInvoicesChargesStatus) || 0
      }))
    };

    dispatch(
      getSubmitAllAddChargeAction(payloadData)
    )
  }
  const getExportDataResponse = useSelector(
    (state) => state.documentReducer.exportData.responseData?.exported_file
  );
  const getExportDataApiCallResponse = useSelector(
    (state) => state.documentReducer.exportDataApiCall
  );

  useEffect(() => {
    if (getExportDataResponse != null && true == getExportDataApiCallResponse) {
      dispatch(getExportDataApiCall(false));
      if ("excel" == exportType) {
        Base64ToExcelDownload(
          getExportDataResponse,
          "SellerTaxInvoiceDetails.xlsx"
        );
      } else {
        uploadedFileDownload(
          getExportDataResponse,
          "SellerTaxInvoiceDetails.pdf",
          `data:application/pdf;base64`
        );
      }
    }
  });

  const ChargebyIddata = useSelector(
    (state) => state?.SellerTaxgen?.ChargeById?.responseData
  );
  let getAllTaxInvoiceResponseAllData = useSelector(
    (state) => state?.SellerTaxgen?.getAllSellerTaxGen
  );

  useEffect(() => {
    dispatch(
      getAllTaxInvoiceBuyerAction({
        season: TaxInvoiceSearch.season,
        auctionCenterId: atob(window.location.pathname.split("/")[4]),
      })
    );
    // dispatch(getAllTaxInvoiceGenAction()); //This Api fails everytime shows 404 error when user comes to this page :: commented By Jay


    dispatch(
      getAuctiondataAction({
        auctionCenterId: atob(window.location.pathname.split("/")[4]),
        roleCode: "SELLER",
      })
    );
    // dispatch(
    //   getAllSubmitChargeAction({
    //     invoiceDeatilsId: "1704",
    //   }).
    // );
    // dispatch(getAllSellerTaxGenBuyerAction());
    dispatch(getAllTeaTypes());
    // dispatch(getAllSellerTaxGenSaleGenAction());
    dispatch(
      fetchMarkRequest({
        auctionCenterId: atob(window.location.pathname.split("/")[4]),
      })
    );
    dispatch(fetchAuctionRequest());
    dispatch(getAllCategoriesAction());
    // dispatch(fetchGradeRequest()); unnecessary API calls showing 404 not found error code commented by Jay.
    dispatch(fetchUser());
    dispatch(getBuyer({ roleCode: "BUYER", userType: 2, isParentId: 0 }));
  }, []);

  useEffect(() => {
    if (TaxInvoiceSearch.saleNo) {
      dispatch(
        getAllTaxInvoiceSaleAction({
          season: TaxInvoiceSearch.season,
          saleNo: TaxInvoiceSearch.saleNo,
          auctionCenterId: atob(window.location.pathname.split("/")[4]),
        })
      );
      dispatch(
        getAllTaxInvoiceLotAction({
          season: TaxInvoiceSearch.season,
          saleNo: TaxInvoiceSearch.saleNo,
          auctionCenterId: atob(window.location.pathname.split("/")[4]),
          pageNumber: 1,
          pageSize: 10,
        })
      );
      dispatch(
        getAllSellerTaxInvoiceSessionAction({
          season: TaxInvoiceSearch.season,
          saleNo: TaxInvoiceSearch.saleNo,
          auctionDate: TaxInvoiceSearch.auctionDate,
          auctionCenterId: atob(window.location.pathname.split("/")[4]),
        })
      );
    }
  }, [TaxInvoiceSearch.saleNo])

  const getUserData = useSelector(
    (state) => state.createBuyer.getBuyer.responseData
  );
  useEffect(() => {
    setallTeaTypeList(allTeaType);
    setallMarkList(markList);
    setallAuctionCenterList(getAllAuctionCenterList);
    setallCategory(allActiveCategory);
    setallGrade(grades);
    setallBuyer(getUserData);
  }, [
    allTeaType,
    currentYear,
    markList,
    getAllAuctionCenterList,
    allActiveCategory,
    grades,
    getUserData,
  ]);

  const handleAddchargeId = (invoiceid, mode) => {
    let invoiceId = invoiceid.split(",")[0]
    dispatch(getChargeTaxByIdAction(invoiceId));
    setMode(mode);
    if (mode == "Add") {
      setShowmodalCharge(true);
    }
    else {
      setShowViewModalCharge(true);
    }
  };

  const handleUploadClick = () => {
    let selectedBuyer = getAllTaxInvoiceResponse.filter(
      (viewTaxInvoiceData) => viewTaxInvoiceData.isSelected
    );

    if (selectedBuyer.length === 0) {
      toast.error("Please select at least one data to upload.");
      return;
    }

    setModalOpen(true);
  };

  const handleImportExcelClick = (exportTypes) => {
    setexportTypes("");
    let selectedBuyer = [];
    getAllTaxInvoiceResponse &&
      getAllTaxInvoiceResponse.map(
        (viewTaxInvoiceData, viewTaxInvoiceDataIndex) => {
          if (
            viewTaxInvoiceData &&
            viewTaxInvoiceData.isSelected &&
            true == viewTaxInvoiceData.isSelected
          ) {
            let tempData = {
              invoiceNo: viewTaxInvoiceData.invoiceNo,
              invoiceDate: viewTaxInvoiceData.invoiceDate,
              buyerGSTIN: viewTaxInvoiceData.buyerGSTIN,
              invoiceValue: viewTaxInvoiceData.totalInvoiceAmount,
              transferId: viewTaxInvoiceData.transferId,
              invoiceId: viewTaxInvoiceData.invoiceid,
              ackDate: "",
              ackNo: "",
              irn: "",
              ewb: "Success",
              userId: userId,
            };

            selectedBuyer.push(tempData);
          }
        }
      );
    if (selectedBuyer && selectedBuyer.length == 0) {
      toast.error("Please select at least one data to generate GST IRN.");
      return;
    }
    setexportTypes(exportTypes);
    let payload = {
      url: "postauction/gst/exportIrns",
      data: selectedBuyer,
    };
    dispatch(getExportDataSeller(payload));
    setcatshowmodal(false);
    setIsAllSelected(false);
    setConfirmationModalVisible(false);
    dispatch(getAllTaxInvoiceActionSuccess([]));
  };

  // function Actiontab() {
  //   <div class="Action">
  //     {modalRight?.some((ele) => ele === "64") && (
  //       <i
  //         className="fa fa-add"
  //         onClick={() => handleAddchargeId(invoiceId)}
  //       ></i>
  //     )}
  //   </div>;
  // }


  const callApi = (e, buttonValue) => {
    e.preventDefault(); // Prevent default form submission behavior
    if (editingCharge?.remarks == "") {
      CustomToast.error("Please enter remarks.");
      return;
    }
    if (buttonValue != 1) {
      // Show confirmation dialog
      const confirmSubmit = window.confirm(
        "Charges cannot be edited once it is submitted. Are you sure, you want to submit?"
      );

      // If user cancels, exit the function
      if (!confirmSubmit) {
        return;
      }
    }


    let dataForSubmit = {
      invoiceId: goodsInvoicesChargesStatus,
      markId: markId,
      pils: editingCharge?.pils ? editingCharge?.pils : "0.00",
      sellerChestageAllowance: editingCharge?.sellerChestageAllowance
        ? editingCharge?.sellerChestageAllowance
        : "0.00",
      sptfRecovery: editingCharge?.sptfRecovery
        ? editingCharge?.sptfRecovery
        : "0.00",
      damageClaims: editingCharge?.damageClaims
        ? editingCharge?.damageClaims
        : "0.00",
      withdrawnCharges: editingCharge?.withdrawnCharges
        ? editingCharge?.withdrawnCharges
        : "0.00",
      withdrawnSGST: editingCharge?.withdrawnSGST
        ? editingCharge?.withdrawnSGST
        : "0.00",
      withdrawnCGST: editingCharge?.withdrawnCGST
        ? editingCharge?.withdrawnCGST
        : "0.00",
      withdrawnIGST: editingCharge?.withdrawnIGST
        ? editingCharge?.withdrawnIGST
        : "0.00",
      freightCharges: editingCharge?.freightCharges
        ? editingCharge?.freightCharges
        : "0.00",
      remarks: editingCharge?.remarks ? editingCharge?.remarks : "",
      buttonStatus: buttonValue,
      listOfSellerChargesIds: AddchargeId.listOfSellerChargesIds,
      listOfSPTFRecoveryids: AddchargeId.listOfSPTFRecoveryid,
      netWarehouseCharges: totCharge,

      ...(buttonValue === 2 && {
        grossTeaValueAmount: editingCharge?.grossTeaValueAmount
          ? editingCharge?.grossTeaValueAmount
          : "",
        totalChargesOfSellerAndWarehouse: total,
        netAmount: netAmount,
      })


    };

    const apiUrl = "/postauction/sellertaxinvoice/goodsInvoiceCharge";

    axiosMain
      .post(apiUrl, dataForSubmit)
      .then((response) => {
        if (response.data.statusCode === 200) {
          CustomToast.success(response.data.message);
        } else {
          CustomToast.error(response.data.message);
        }
      })
      .catch((error) => {
        // Handle error
        console.error("Error:", error);
      });
  };


  useEffect(() => {
    // Helper function to ensure we only work with floats and round to two decimal places
    const toFloat = (value) => parseFloat(value) || 0;

    // Calculate total using float values
    const totalCharges =
      toFloat(editingCharge?.pils) +
      toFloat(editingCharge?.sellerChestageAllowance) +
      toFloat(editingCharge?.damageClaims) +
      toFloat(editingCharge?.withdrawnCharges) +
      toFloat(editingCharge?.freightCharges) +
      toFloat(AddchargeId?.netWarehouseCharges) 
      // toFloat(editingCharge?.withdrawnSGST) +
      // toFloat(editingCharge?.withdrawnCGST) +
      // toFloat(editingCharge?.withdrawnIGST)

    const totalAuctioneerCharges =
      toFloat(editingCharge?.pils) +
      toFloat(editingCharge?.sellerChestageAllowance) +
      toFloat(editingCharge?.damageClaims) +
      toFloat(editingCharge?.withdrawnCharges) +
      toFloat(editingCharge?.freightCharges) 
      // toFloat(editingCharge?.withdrawnSGST) +
      // toFloat(editingCharge?.withdrawnCGST) +
      // toFloat(editingCharge?.withdrawnIGST)


    // Round totalCharges to two decimal places and set total
    settotal(parseFloat(totalCharges.toFixed(2)));

    // Calculate netAmount with float values
    const sptfRecoveryValue = toFloat(editingCharge?.sptfRecovery);
    const grossTeaValue = toFloat(editingCharge?.grossTeaValueAmount);
    const atosellerInvoiceAmount = showmodalCharge ? toFloat(editingCharge?.atosInvoiceAmount) + totalAuctioneerCharges : toFloat(editingCharge?.atosInvoiceAmount) ;
    const tboardtoSellerInvoiceAmount = toFloat(editingCharge?.ttoSInvoiceAmount);
    const netAmount = grossTeaValue - AddchargeId?.netWarehouseCharges - atosellerInvoiceAmount - tboardToSellerInvoiceAmount - sptfRecoveryValue;

    // Round netAmount to two decimal places and set netAmount
    setnetAmount(parseFloat(netAmount.toFixed(2)));
    setGrossTeaValue(grossTeaValue);
    settotCharge(AddchargeId?.netWarehouseCharges);
    setAuctioneerToSellerInvoiceAmount(atosellerInvoiceAmount);
    setTboardToSellerInvoiceAmount(tboardtoSellerInvoiceAmount);
  }, [
    AddchargeId?.grossTeaValueAmount,
    editingCharge?.pils,
    editingCharge?.sellerChestageAllowance,
    editingCharge?.sptfRecovery,
    editingCharge?.damageClaims,
    editingCharge?.withdrawnCharges,
    editingCharge?.freightCharges,
    AddchargeId?.netWarehouseCharges,
    editingCharge?.withdrawnSGST,
    editingCharge?.withdrawnCGST,
    editingCharge?.withdrawnIGST,

  ]);

  // useEffect(() => {
  //   const newRows = getAllTaxInvoiceResponse || [];
  //   setRows((prevRows) => {
  //     const currentRows = Array.isArray(prevRows) ? [...prevRows] : [];

  //     if (newRows.length > 0) {
  //       const index = currentRows.findIndex(
  //         (row) => row.invoiceid === newRows[0].invoiceid
  //       );

  //       if (index !== -1) {
  //         currentRows[index] = newRows[0];
  //         return currentRows;
  //       } else {
  //         return [...currentRows, ...newRows];
  //       }
  //     } else {
  //       return currentRows;
  //     }
  //   });
  // }, [getAllTaxInvoiceResponse]);

  useEffect(() => {
    const newRows = getAllTaxInvoiceResponse || [];
    if (newRows?.length < 20) {
      setIsDisabled(true);
    }
    else {
      setIsDisabled(false);
    }
    setRows(newRows);
  }, [getAllTaxInvoiceResponse]);

  useEffect(() => {
    if (invoieceGenerateListData?.exported_file == undefined) {
      setinvoieceGenerateList(invoieceGenerateListData)
    } else {
      if ("excel" == exportType) {
        Base64ToExcelDownload(invoieceGenerateListData.exported_file, "InvoiceData.xlsx");
      } else {
        uploadedFileDownload(
          invoieceGenerateListData.exported_file,
          "InvoiceData.pdf",
          `data:application/pdf;base64`
        );
      }
      setexportType("")
    }
  }, [invoieceGenerateListData])

  useEffect(() => {
    if (invoieceGenerateList && Array.isArray(invoieceGenerateList)) {
      let grossTeaValue = 0;
      let totalCharges = 0;
      let netAmount = 0;
      let totalSftp = 0;

      for (let i = 0; i < invoieceGenerateList.length; i++) {
        const taxInvoice = invoieceGenerateList[i];

        // Check if the values are valid numbers before adding to totals
        const grossTeaValueAmount = parseInt(taxInvoice.grossTeaValueAmount);
        const totalChargesValue = parseInt(
          taxInvoice.totalChargesofSellerandWarehouse
        );
        const netAmountPaidValue = parseInt(
          taxInvoice.netAmountPaidToWarehouse
        );
        const totalSftpValue = parseInt(
          taxInvoice.totalChargesofSellerandWarehouse
        );

        // Check if the parsed values are valid numbers
        if (!isNaN(grossTeaValueAmount)) {
          grossTeaValue += grossTeaValueAmount;
        }

        if (!isNaN(totalChargesValue)) {
          totalCharges += totalChargesValue;
        }

        if (!isNaN(netAmountPaidValue)) {
          netAmount += netAmountPaidValue;
        }

        if (!isNaN(totalSftpValue)) {
          totalSftp += totalSftpValue;
        }
      }

      // Set state with the updated values
      // settotCharge(grossTeaValue);
      setnetAmount(totalCharges);
      setGrossTeaValue(grossTeaValue)
      setgrossTea(netAmount);
      settotSftp(totalSftp);
    }
  }, [getAllTaxInvoiceResponse]);

  useEffect(() => {
    if(netAmount < 0) {
      setButtonDisabled(true)
    } else {
      setButtonDisabled(false)
    }
  },[netAmount])

  const handleClear = () => {
    setpils("0.00");
    setsellerChestageAllowance("0.00");
    setsptfRecovery("0.00");
    setdamageClaims("0.00");
    setwithdrawnCharges("0.00");
    setwithdrawnSGST("");
    setwithdrawnCGST("");
    setwithdrawnIGST("");
    setfreightCharges("0.00");
    setremarks("");
    seteditingCharge({});
    settotal(0);
    setGrossTeaValue(0);
    setnetAmount(0);
  };

  const handleAddcharge = () => {
    handleClear();
    setShowmodalCharge(false);
    setShowViewModalCharge(false)
  };
  const checkBoxAllSelected = (value) => {
    let tempData = [...rows]; // Copy of rows array
    if (!rows) {
      // Handle the case when rows are undefined
      return;
    }
    // Loop through each row and call checkBoxSelect for each index
    tempData.forEach((row, index) => {
      checkBoxSelect(index, "isSelected", value, true); // Pass parameters to checkBoxSelect
    });
    setIsAllSelected(value);
  };
  const checkBoxSelect = (index, key, value, isSingleSelected) => {
    let tempData = [];
    const updatedSelectedInvoices = [...selectedInvoices];

    if (!rows) {
      // Handle the case when getAllTaxInvoiceResponse is undefined
      return;
    }

    const updatedRows = [...rows];
    updatedRows[index].isSelected = !updatedRows[index]?.isSelected;

    const selectedInvoiceNos = updatedRows
      .filter((row) => row.isSelected)
      .map((row) => row.invoiceid);

    setSelectedInvoices(selectedInvoiceNos);
    setRows(updatedRows);

    if (isSingleSelected == true) {
      tempData = rows.map((viewTaxInvoiceData, viewTaxInvoiceDataIndex) => {
        if (index == viewTaxInvoiceDataIndex) {
          viewTaxInvoiceData[key] = value;
        }
        return viewTaxInvoiceData;
      });

      let isAllSelected = rows.every(
        (ViewDealBookTaoData) => ViewDealBookTaoData?.isSelected
      );

      setIsAllSelected(isAllSelected);
    } else {
      tempData = rows.map((viewTaxInvoiceData, viewTaxInvoiceDataIndex) => {
        viewTaxInvoiceData[key] = value;
        return viewTaxInvoiceData;
      });
      setIsAllSelected(value);
    }

    getAllTaxInvoiceResponse = tempData;
  };

  // let temGetAllTaxInvoiceResponseAllData = getAllTaxInvoiceResponseAllData;
  // temGetAllTaxInvoiceResponseAllData.responseData = tempData;
  // dispatch(
  //   getAllSellerTaxGenActionSuccess(temGetAllTaxInvoiceResponseAllData)
  // );

  const handleViewClickid = (invoiceid, markId, goodsInvoicesCharges, goodsInvoiceRefNo, status) => {
    let data = {
      invoiceDetailId: invoiceid

    }
    dispatch(getSellerTaxGenByIdAction(data));
    setinvoiceId(invoiceid);
    setStatus(status);
    setMarkId(markId);
    setgoodsInvoicesChargesStatus(goodsInvoicesCharges);
    setgoodsInvoiceReferenceNo(goodsInvoiceRefNo);
    setShowmodal(true);
  };

  const currentDate = new Date();
  const [serialNumber, setserialNumber] = useState([]);
  const [selectedserialNumber, setselectedserialNumber] = useState("");
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [viewcertificateDetail, setviewcertificateDetail] = useState({});
  const [Loading, setloading] = useState(false);
  const [Base64Data, setBase64Data] = useState([]);
  const [Base64savedigitalsign, setBase64savedigitalsign] = useState([]);
  const [showOwnerModalHistory, setShowCirtificateModal] = useState(false);
  const HideCirtificateModal = () => setShowCirtificateModal(false);
  const handleUploadDocument = () => {
    if (uploadedFiles.length === 0) {
      setUploadDocumentError("Please select a file.");
    } else {
      let selectedBuyer = [];
      rows &&
        rows.map((viewTaxInvoiceData, viewTaxInvoiceDataIndex) => {
          if (
            viewTaxInvoiceData &&
            viewTaxInvoiceData.isSelected &&
            true == viewTaxInvoiceData.isSelected
          ) {
            selectedBuyer.push(viewTaxInvoiceData.invoiceNo);
          }
        });

      if (selectedBuyer && selectedBuyer.length > 1) {
        toast.error("Must be select only one record");
        return;
      }

      const apiPayload = uploadedFiles.map((file) => ({
        base64: file.documentContent,
        filename: file.documentName,
        listOfBUyerInvoiceId: selectedInvoices,
        userId: atob(sessionStorage.getItem("argument2")),
      }));
      let urls = "postauction/sellertaxinvoice/gstresponse";
      dispatch(
        getGstExcelByIdAction({ urls, apiPayload: apiPayload && apiPayload[0] })
      );
      setUploadDocumentError(null);
      setModalOpen(false);
      setUploadedFiles("");
      removeAllFiles("");
      setcatshowmodal(false);
      setIsAllSelected(false);
      setConfirmationModalVisible(false);
      dispatch(getAllTaxInvoiceActionSuccess([]));
      const inputElement = document.getElementById("individualTaxInvoice");
      if (inputElement) {
        inputElement.value = "";
      }
    }
  };
  const removeAllFiles = () => {
    setUploadedFiles([]);
    // onFileSelect([]);
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.value = "";
    }
  };
  const ViewCertificates = async () => {
    const url = "https://localhost:29739/teaboard/signer";
    try {
      const data = {
        action: "1",
        serialNumber: selectedserialNumber,
        data: null,
        publicKey: null,
        key: null,
      };

      if (data.serialNumber != "" || data.serialNumber != null) {
        const response = await axios.post(url, qs.stringify(data), {});
        setviewcertificateDetail(
          response?.data?.signerResponse?.certificateDetail
        );
        var datas = response.data.signerResponse?.certificateDetail;
        const keyValuePairs =
          response.data.signerResponse?.certificateDetail.clientName.split(",");
        const cnField = keyValuePairs.find((pair) => pair.includes("CN="));
        const name = cnField.split("=")[1].trim();

        datas.clientName = name;
        setShowCirtificateModal(true);
      } else {
        CustomToast.error("Please select certificate");
        setShowCirtificateModal(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };
  const handleSGSTChange = (e) => {
    if (!viewMode) {
      const sgstValue = parseFloat(e.target.value) || 0;
      const newValues = {
        withdrawnSGST: sgstValue,
        withdrawnCGST: sgstValue,
      };

      if (editingCharge) {
        seteditingCharge({
          ...editingCharge,
          ...newValues,
        });
      } else {
        setwithdrawnSGST(newValues.withdrawnSGST);
        setwithdrawnCGST(newValues.withdrawnCGST);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const url = "https://localhost:29739/signer";
      try {
        const data = {
          action: "0",
          serialNumber: null,
          data: null,
          publicKey: null,
          key: null,
        };
        console.log(qs.stringify(data));
        const response = await axios.post(url, qs.stringify(data), {});
        setserialNumber(response?.data?.signerResponse?.certificates);
        console.log("Response:", serialNumber);
      } catch (error) {
        console.error("Error:", error.message);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setTaxInvoiceSearch({
      season: seasonYear,
      saleNo: null,
      roleCode: null,
      userId: null,
      einvoiceEligibility: null,
      status: null,
      mark: null,
      Seller: null,
      bilingType: null,
    });
    setRows([]);
    pageNo = 1;
    setpils("0.00");
    setsellerChestageAllowance("0.00");
    setsptfRecovery("0.00");
    setdamageClaims("0.00");
    setwithdrawnCharges("0.00");
    setwithdrawnSGST("");
    setwithdrawnCGST("");
    setwithdrawnIGST("");
    setfreightCharges("0.00");
    settotal(0);
    setnetAmount(0);
    setGrossTeaValue(0);
    setremarks("");
    seteditingCharge({});
    setShowmodal(false);
    setShowmodalCharge(false);
    setShowViewModalCharge(false)
    dispatch(getAllSellerTaxGenActionSuccess([]));
  }, []);

  const handleDropdownChange = (event) => {
    const selectedSerialNumber = event.target.value;
    setselectedserialNumber(selectedSerialNumber);
  };

  useEffect(() => {
    const fetchData = async () => {
      const url = "https://localhost:29739/signer";

      try {
        const data = {
          action: "0",
          serialNumber: null,
          data: null,
          publicKey: null,
          key: null,
        };
        console.log(qs.stringify(data));
        const response = await axios.post(url, qs.stringify(data), {});
        setserialNumber(response?.data?.signerResponse?.certificates);
        console.log("Response:", serialNumber);
      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    fetchData();
  }, []);

  const handlePostRequest = async () => {
    if (selectedInvoices?.length > 0 && selectedserialNumber !== null) {
      const url = "https://localhost:29739/teaboard/signer";
      const data = {
        action: "1",
        serialNumber: selectedserialNumber,
        data: null,
        publicKey: null,
        key: null,
      };
      const response = await axios.post(url, qs.stringify(data), {});
      const validTo = response.data.signerResponse.certificateDetail.validTo;
      const validDate = moment(validTo).format("YYYY-MM-DD HH:mm:ss");
      const currentDates = moment(currentDate).format("YYYY-MM-DD HH:mm:ss");
      console.log("Valid Date:", validDate);
      console.log("Current Date:", currentDates);
      const validD = new Date(validDate);
      const currentD = new Date(currentDates);
      const current_date = new Date();
      const isBetweenDates = currentD <= current_date && current_date <= validD;
      if (isBetweenDates) {
        setloading(true);
        try {
          const response = await axiosMain.post(
            "/postauction/sellertaxinvoice/base64DigitalSign",
            {
              base64: "",
              filename: "",
              invoiceNo: "",
              invoicenolist: null,
              listOfBUyerInvoiceId: selectedInvoices,
              userId: userId,
            }
          );
          if (response.data.statusCode === 200) {
            const base64Data = response.data.responseData;
            setBase64Data(base64Data);
            const url = "https://localhost:29739/teaboard/signer";
            try {
              const data = {
                action: "1",
                serialNumber: selectedserialNumber,
                data: null,
                publicKey: null,
                key: null,
              };
              if (data.serialNumber != "" || data.serialNumber != null) {
                const response = await axios.post(url, qs.stringify(data), {});
                setviewcertificateDetail(
                  response?.data?.signerResponse?.certificateDetail
                );
                var datas = response.data.signerResponse?.certificateDetail;
                const keyValuePairs =
                  response.data.signerResponse?.certificateDetail.clientName.split(
                    ","
                  );
                const cnField = keyValuePairs.find((pair) =>
                  pair.includes("CN=")
                );
                const name = cnField.split("=")[1].trim();

                datas.clientName = name;
              } else {
                CustomToast.error("Please select certificate");
                setShowCirtificateModal(false);
              }
            } catch (error) {
              console.error("Error:", error.message);
            }
            console.log("response.data", response.data);
            for (const name of base64Data) {
              const signData = {
                signPlace: "1",
                serialnumber: selectedserialNumber,
                documentContent: name.base64,
                documentTitle: name.filename,
                organnizationName: "-",
                place: "-",
                certificateName: datas.clientName,
              };
              console.log("Location", signData);
              const response = await axios.post(
                "https://localhost:29739/teaboard/livesign/pdfsigner",
                signData
              );
              setBase64savedigitalsign(response.data);
              console.log("Response from pdfsigner:", response.data);
              if (response.data !== null && response.data !== "") {
                const data1 = [
                  {
                    base64: response.data.base64,
                    filename: name.filename,
                    invoiceNo: name.invoiceNo,
                    invoicenolist: selectedInvoices,
                  },
                ];
                const response1 = await axiosMain.post(
                  "/postauction/sellertaxinvoice/saveDigitalSign",
                  data1
                );
                if (response1.data.statusCode === 200) {
                  CustomToast.success(response1.data.message);
                } else {
                  CustomToast.error(response1.data.message);
                }
              }
            }
          } else {
            setBase64Data([]);
          }
        } catch (error) {
          console.error("Error making POST request to Digitalsign:", error);
        } finally {
          setloading(false);
        }
      } else {
        CustomToast.error(response.data.message);
      }
    } else {
      CustomToast.error("Please select rows and select certificate");
    }
  };
  const handleExportIndividual = (exportType, invoiceDetailId) => {
    setexportType(exportType)
    let data = {
      exportType: exportType,
      invoiceDetailId: invoiceDetailId,
      isExport: 1
    }

    dispatch(getSellerTaxGenByIdAction(data));
  }

  return (
    <>
      <div>
        <div>
          <form onSubmit={SearchViewDealBook}>
            <div className="row">
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Mark</label>
                  <select
                    name="mark"
                    value={TaxInvoiceSearch.mark}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Mark</option>
                    {markList?.map((markList, index) => (
                      <option value={markList.markId}>
                        {markList.markName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Seller</label>
                  <select
                    name="Seller"
                    value={TaxInvoiceSearch.Seller}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Seller</option>
                    {auctionlist?.map((auctionlist, index) => (
                      <option value={auctionlist.id}>
                        {auctionlist.value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Season</label>
                  <label className="errorLabel"> * </label>
                  <select
                    name="season"
                    value={TaxInvoiceSearch.season}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select Season</option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Sale No</label>
                  <label className="errorLabel"> * </label>
                  <select
                    name="saleNo"
                    onChange={handleViewDealSearch}
                    value={TaxInvoiceSearch.saleNo}
                    className="form-control select-form"
                  >
                    <option value="">Select Sale No</option>
                    {BuyerList?.map((saleNoItem, index) => (
                      <option value={saleNoItem.saleNo} key={index}>
                        {saleNoItem.saleNo}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label>Status Dropdown</label>
                  <select
                    name="bilingType"
                    value={TaxInvoiceSearch.bilingType}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="1">All</option>
                    <option value="2">Charges not applied</option>
                    <option value="3">Charges saved</option>
                    <option value="4">Charges submitted</option>
                  </select>
                </div>
              </div>

              <div className="col-xl-2">
                <div className="FomrGroup">
                  <label> E-Invoice Eligibility </label>
                  <select
                    name="einvoiceEligibility"
                    value={TaxInvoiceSearch.einvoiceEligibility}
                    className="form-control select-form"
                    onChange={handleViewDealSearch}
                  >
                    <option value="">Select E-Invoice Eligibility</option>
                    <option value="1">Yes </option>
                    <option value="0">No </option>
                  </select>
                </div>
              </div>

              <div className="col-12">
                <div className="BtnGroup">
                  <button
                    type="submit"
                    className="SubmitBtn"
                    onClick={searchData}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="SubmitBtn"
                    onClick={ResetViewBook}
                  >
                    Clear
                  </button>
                  {/* <div className="col-xl-2">
                    <div className="FomrGroup">
                      <label>Certificates </label>
                      <select
                        name="auctionDate"
                        value={selectedserialNumber}
                        className="form-control select-form"
                        onChange={handleDropdownChange}
                      >
                        <option value="">Select Certificate </option>
                        {serialNumber?.map((item) => (
                          <option
                            key={item.serialNumber}
                            value={item.serialNumber}
                          >
                            {item.clientName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="SubmitBtn"
                    onClick={() => handlePostRequest()}
                    disabled={Loading == true}
                  >
                    Digital sign
                    {Loading == true ? (
                      <>
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </button> */}
                  {rows?.length > 0 ? (
                    <>
                      {modalRight?.some((ele) => ele === "48") && (
                        <button
                          class="SubmitBtn"
                          title="Export Excel"
                          onClick={() => handleExport("excel")}
                        >
                          <i class="fa fa-file-excel"></i>
                        </button>
                      )}
                      {modalRight?.some((ele) => ele === "47") && (
                        <button
                          class="SubmitBtn"
                          title="Export PDF"
                          onClick={() => handleExport("pdf")}
                        >
                          <i class="fa fa-file-pdf"></i>
                        </button>
                      )}
                      {modalRight?.some((ele) => ele === "56") && (
                        <button
                          type="button"
                          className="Excel"
                          title="Invoice Generate"
                          onClick={() => confirmInvoiceGeneration()}
                        >
                          <i className="fa fa-download"></i>
                        </button>
                      )}
                      <button
                        class="SubmitBtn"
                        title="Submit Charges"
                        disabled={isAllChargeButtonDisabled || isSubmitChargeApiCalling}
                        onClick={() => handleSubmitAllCharge()}
                      >
                        Submit Charges
                        {isSubmitChargeApiCalling == true ? (
                          <>
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </button>
                      {/* {modalRight?.some((ele) => ele === "54") && (
                        <button
                          class="SubmitBtn"
                          onClick={() => handleImportExcelClick()}
                        >
                          GST Excel
                        </button>
                      )}
                      {modalRight?.some((ele) => ele === "55") && (
                        <button
                          className="SubmitBtn"
                          onClick={() => handleUploadClick()}
                        >
                          IRN Upload Document
                        </button>
                      )} */}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
        {modalRight?.some((ele) => ele === "12") && (
          <div className="row mt-4">
            <div className="col-12">
              <div className="TableBox11">
                <table className="table11" ref={tableRef}>
                  <thead>
                    <tr>
                      {rows?.length > 0 ? (
                        <th>
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={(e) =>
                              checkBoxAllSelected(e.target.checked)
                            }
                          />
                        </th>
                      ) : (
                        ""
                      )}
                      <th>Sr.</th>
                      <th>Reference No.</th>
                      <th>Seller</th>
                      <th>Mark</th>
                      <th>Category</th>
                      <th>Tea Type</th>
                      <th>Sale Date</th>
                      <th>Tea Total Invoice Amount</th>
                      <th>Auctioneer Invoice No</th>
                      <th>Auctioneer Total Invoice Amount</th>
                      <th>Tea Board Invoice Amount</th>
                      <th>Seller Proceeds</th>
                      <th>Status</th>
                      <th>Auctioneer Eligibility</th>
                      <th>Auctioneer to Seller Ack. No.</th>
                      <th>Auctioneer to Seller IRN</th>
                      <th>Tea Board Eligibility</th>
                      <th>Tea Board to Auctioneer Ack. No.</th>
                      <th>Tea Board to Auctioneer IRN</th>
                      <th>Tea Board to Seller Ack. No.</th>
                      <th>Tea Board to Seller IRN</th>
                      <th>Tea board to Warehouse IRN Generated Status.</th>
                      <th>Tea board SPTF Invoice No.</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <>
                        <div className="">
                          <ThreeDots
                            visible={true}
                            height="80"
                            width="80"
                            color="#4fa94d"
                            radius="9"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {rows?.length > 0 ? (
                          <>
                            {rows?.map((data, index) => (
                              <tr key={index} style={{ cursor: 'pointer' }} onDoubleClick={() => {
                                handleViewClickid(data.goodsInvoiceId, data.markId, data.goodsInvoicesChargesStatus, data.goodsInvoiceReferenceNo, data.status)
                              }}>
                                <td className={getStatusClass(data.status)}>
                                  <input
                                    type="checkbox"
                                    checked={data && data.isSelected}
                                    onDoubleClick={(e) => {e.preventDefault()
                                    e.stopPropagation()}}
                                    onChange={(e) =>
                                      checkBoxSelect(
                                        index,
                                        "isSelected",
                                        e.target.checked,
                                        true
                                      )
                                    }
                                  />
                                </td>
                                <td className={getStatusClass(data.status)}>{index + 1}</td>
                                <td className={getStatusClass(data.status)}>{data.goodsInvoiceReferenceNo}</td>
                                <td className={getStatusClass(data.status)}>{data.sellerName}</td>
                                <td className={getStatusClass(data.status)}>{data.mark}</td>
                                <td className={getStatusClass(data.status)}>{data.category}</td>
                                <td className={getStatusClass(data.status)}>{data.teaType}</td>
                                <td className={getStatusClass(data.status)}>{data.saleDate}</td>
                                <td className={getStatusClass(data.status)}>{data.teaTotalInvoiceAmount}</td>
                                <td className={getStatusClass(data.status)}>{data.auctioneerInvoiceNo}</td>
                                <td className={getStatusClass(data.status)}>{data.auctioneerTotalInvoiceAmount}</td>
                                <td className={getStatusClass(data.status)}>{data.teaBoardInvoiceAmount}</td>
                                <td className={getStatusClass(data.status)}>{data.sellerProceeds}</td>
                                <td className={getStatusClass(data.status)}>{getStatusData(data.status)}</td>
                                <td className={getStatusClass(data.status)}>{data.auctioneerEligibility == 0 ? "No" : "Yes"}</td>
                                <td className={getStatusClass(data.status)}>{data.auctioneerToSellerAckNo}</td>
                                <td className={getStatusClass(data.status)}>{data.auctioneerToSellerIRN}</td>
                                <td className={getStatusClass(data.status)}>{data.teaBoardEligibility}</td>
                                <td className={getStatusClass(data.status)}>{data.teaBoardtoAuctioneerAckNo}</td>
                                <td className={getStatusClass(data.status)}>{data.teaBoardtoAuctioneerIrn}</td>
                                <td className={getStatusClass(data.status)}>{data.teaBoardtoSellerAckNo}</td>
                                <td className={getStatusClass(data.status)}>{data.teaBoardtoSellerIrn}</td>
                                <td className={getStatusClass(data.status)}>{data.teaboardtoWarehouseIRNGeneratedStatus}</td>
                                <td className={getStatusClass(data.status)}>{data.teaboardSPTFInvoiceNo}</td>
                                {/* <td>{data.invoicedetailid}</td>
                                <td>{data.invoiceid}</td>
                                <td>{data.transferid}</td> */}
                                <td className={`Action text-center ${getStatusClass(data.status)}`}>
                                  {data.dealStatus === 4 ? (
                                    <></>
                                  ) : (
                                    <>
                                      {modalRight?.some(
                                        (ele) => ele === "3"
                                      ) && (
                                          <i
                                            className="fa fa-eye"
                                            title="View"
                                            onClick={() =>
                                              handleViewClickid(data.goodsInvoiceId, data.markId, data.goodsInvoicesChargesStatus, data.goodsInvoiceReferenceNo, data.status)
                                            }
                                          ></i>
                                        )}
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={31}>
                              <div className="NoData">No record found</div>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              {/* {rows?.length > 19 ? ( */}
              {/* <>
                <button
                  class="SubmitBtn"
                  onClick={handleViewMore}
                  disabled={
                    (!rows || rows.length % 20 !== 0 || rows.length <= 0) || isDisabled
                  }
                >
                  View More
                </button>
              </> */}
              {/* // ) : (
              //   ""
              // )} */}
            </div>
          </div>
        )}

        
        <div className="row row-light-grey mt-2">

          <div className="col-auto">
            <div class="status-bx">
              <span class="status-color-bx custom_light_GREEN"></span>
              <span class="status-name"> Charges Submitted </span>
            </div>
          </div>

          <div className="col-auto">
            <div class="status-bx">
              <span class="status-color-bx custom_ORANGE"></span>
              <span class="status-name"> Charges Saved</span>
            </div>
          </div>

          <div className="col-auto">
            <div class="status-bx">
              <span class="status-color-bx custom_WHITE"></span>
              <span class="status-name"> Charges not applied </span>
            </div>
          </div>


        </div>
      </div>
      {showmodal && (
        <Modal show={showmodal} onHide={handleViewClick} size="xl" centered>
          <Modal.Header>
            <Modal.Title>Invoice Data</Modal.Title>
            <i className="fa fa-times CloseModal" onClick={handleViewClick}></i>
          </Modal.Header>
          <Modal.Body>
            {modalRight?.some((ele) => ele === "64") && (
              <>
                {/* <div style={{display: "flex", justifyContent: "space-between"}}>
                  <div style={{width: "40%"}}>
                    <p>Reference No. : {invoieceGenerateListData?.[0]?.referenceNo}</p>
                    <p>Seller Name : {invoieceGenerateListData?.[0]?.sellerName}</p>
                    <p>Mark Name: {invoieceGenerateListData?.[0]?.markName}</p>
                    <p>Category Name : {invoieceGenerateListData?.[0]?.categoryName}</p>
                  </div>

                  <div style={{width: "48%"}}>
                    <p>Tea Type : {invoieceGenerateListData?.[0]?.teaTypeName}</p>
                    <p>Season : {invoieceGenerateListData?.[0]?.season}</p>
                    <p>Sale No. : {invoieceGenerateListData?.[0]?.saleNo}</p>
                    <p>Sale Date : {invoieceGenerateListData?.[0]?.saleDate}</p>
                  </div>
                </div> */}

                <div className="row">

                <div className="col-xl-2 col-lg-2 col-md-4">
                    <label>Season</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      value={invoieceGenerateListData?.[0]?.season || ''}
                      disabled
                    />
                  </div>

                  <div className="col-xl-2 col-lg-2 col-md-4">
                    <label>Sale No.</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      value={invoieceGenerateListData?.[0]?.saleNo || ''}
                      disabled
                    />
                  </div>

                  <div className="col-xl-2 col-lg-2 col-md-4">
                    <label>Sale Date</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      value={invoieceGenerateListData?.[0]?.saleDate || ''}
                      disabled
                    />
                  </div>

                  <div className="col-xl-3 col-lg-3 col-md-4">
                    <label>Tea Type</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      value={invoieceGenerateListData?.[0]?.teaTypeName || ''}
                      disabled
                    />
                  </div>

                  <div className="col-xl-3 col-lg-3 col-md-4">
                    <label>Category Name</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      value={invoieceGenerateListData?.[0]?.categoryName || ''}
                      disabled
                    />
                  </div>

                 

                  <div className="col-xl-4 col-lg-2 col-md-4">
                    <label>Mark Name</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      value={invoieceGenerateListData?.[0]?.markName || ''}
                      disabled
                    />
                  </div>

                  <div className="col-xl-4 col-lg-3 col-md-4">
                    <label>Seller Name</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      value={invoieceGenerateListData?.[0]?.sellerName || ''}
                      disabled
                    />
                  </div>

                 

                  <div className="col-xl-4 col-lg-7 col-md-8">
                    <label>Reference No.</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      value={goodsInvoiceReferenceNo || ''}
                      disabled
                    />
                  </div>
                </div>


                <div style={{ display: "flex", gap: "10px" }}>

                  <button
                    type="button"
                    className="SubmitBtn InvoiceData"
                    disabled={sstatus == "2"}
                    onClick={() => handleAddchargeId(goodsInvoicesChargesStatus, "Add")}
                  >
                    Add Charge
                  </button>

                  <button
                    type="button"
                    className="SubmitBtn InvoiceData"
                    disabled={sstatus !== "2"}
                    onClick={() => handleAddchargeId(goodsInvoicesChargesStatus, "View")}
                  >
                    View Charge
                  </button>
                </div>
              </>
            )}
            {/* {invoieceGenerateListData} */}

            <TableComponent
              columns={[
                { name: "taxInvoiceNoForGoods", title: "Tea Invoice No." },
                { name: "buyerName", title: "Invoice Raised On" },
                // { name: "referenceNo", title: "Reference No." },
                { name: "bags", title: "Bags" },
                { name: "invoiceKg", title: "Invoice Kg" },
                { name: "sampleKg", title: "Sample Kg" },
                { name: "netKg", title: "Net Kg" },
                { name: "teaValue", title: "Tea Value" },
                { name: "prsSellerPremium", title: "PRS Seller Premium" },
                { name: "sgstonTeaValue", title: "SGST on Tea Value" },
                { name: "cgstonTeaValue", title: "CGST on Tea Value" },
                { name: "igstonTeaValue", title: "IGST on Tea Value" },
                { name: "teaInvoiceAmount", title: "Tea Invoice Amount" },
                { name: "inspection", title: "Inspection" },
                { name: "reInspection", title: "Re-Inspection" },
                { name: "atosbrokerage", title: "Brokerage" },
                { name: "atosserviceCharge", title: "Service Charges" },
                { name: "atoslotMoney", title: "Lot Money" },
                {
                  name: "sgstonAuctioneerServices",
                  title: "SGST on Auctioneer Services",
                },
                {
                  name: "cgstonAuctioneerServices",
                  title: "CGST on Auctioneer Services",
                },
                {
                  name: "igstonAuctioneerServices",
                  title: "IGST on Auctioneer Services",

                },
                { name: "teaboardCharges", title: "Tea Board to Seller Charges" },
                // {
                //   name: "netAmountPaidToWarehouse",
                //   title: "Net Amount Paid to Warehouse",
                // },
                {
                  name: "sgstonTeaBoardcharges",
                  title: "SGST on Tea Board charges",
                },
                {
                  name: "cgstonTeaBoardcharges",
                  title: "CGST on Tea Board charges",
                },
                {
                  name: "igstonTeaBoardcharges",
                  title: "IGST on Tea Board charges",
                },


                // { name: "sellerName", title: "Seller" },
                // { name: "markName", title: "Mark" },
                // { name: "categoryName", title: "Category" },
                // { name: "teaTypeName", title: "Tea Type" },
                // { name: "season", title: "Season" },
                // { name: "saleNo", title: "Sale No" },
                // { name: "saleDate", title: "Sale date" },
                // { name: "grossValueRs", title: "Gross Value Rs." },

                // {
                //   name: "action",
                //   title: "Action",
                //   getCellValue: (rows) => <Actiontab />,
                // },
              ]}
              rows={
                invoieceGenerateList?.length > 0
                  ? invoieceGenerateList.map((row, index) => ({
                    ...row,
                    index: index + 1,
                    updatedOn: new Date(row.updatedOn).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "short",
                        year: "2-digit",
                      }
                    ),
                  }))
                  : []
              }
              sorting={true}
              dragdrop={false}
              fixedColumnsOn={false}
              resizeingCol={false}
            />
            {invoieceGenerateList?.length > 0 ? (
              <>
                {modalRight?.some((ele) => ele === "48") && (
                  <button
                    class="SubmitBtn"
                    title="Export Excel"
                    disabled={isDownloading}
                    onClick={() => handleExportIndividual("excel", invoieceGenerateList[0].sahilinvoiceDetailId)}
                  >
                    <i class="fa fa-file-excel"></i>
                  </button>
                )}
                &nbsp;&nbsp;
                {modalRight?.some((ele) => ele === "47") && (
                  <button
                    class="SubmitBtn"
                    title="Export PDF"
                    disabled={isDownloading}
                    onClick={() => handleExportIndividual("pdf", invoieceGenerateList[0].sahilinvoiceDetailId)}
                  >
                    <i class="fa fa-file-pdf"></i>
                  </button>
                )}

              </>
            ) : ""}
          </Modal.Body>
        </Modal>
      )}
      {catshowmodal && (
        <Modal show={catshowmodal} onHide={handlecatId} size="lg" centered>
          <Modal.Header>
            <Modal.Title>Select Category</Modal.Title>
            <i className="fa fa-times CloseModal" onClick={handlecatId}></i>
          </Modal.Header>
          <div className="col-xl-4">
            <div className="FormGroup">
              <label>Category</label>
              <select
                name="category"
                value={TaxInvoiceSearch.category}
                className="form-control select-form"
                onChange={handleViewDealSearch}
              >
                <option value="">Select Category</option>
                {allCategory?.map((category, index) => (
                  <option key={index} value={category.categoryName}>
                    {category.categoryName}
                  </option>
                ))}
              </select>
              <div>
                {/* <button
                  type="button"
                  className="Excel"
                  onClick={() => InvoiceGen()}
                >
                  <i className="fa fa-download"></i>
                </button> */}
              </div>
              {categoryError && (
                <div className="error-message">{categoryError}</div>
              )}
            </div>
          </div>
        </Modal>
      )}
      {mode ? (
        <Modal
          show={mode == "Add" ? showmodalCharge : showViewModalCharge}
          onHide={handleViewClick}
          size="xl"
          centered
        >
          <Modal.Header>
            <Modal.Title>{mode == "Add" ? "Add / View Charges " : "View Charges"}</Modal.Title>
            <i className="fa fa-times CloseModal" onClick={handleAddcharge}></i>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <div className="row align-items-end">
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>PILS</label>
                      <input
                        type="number"
                        className="form-control"
                        value={editingCharge?.pils || pils}
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              pils: e.target.value,
                            })
                            : setpils(e.target.value))
                        }
                        disabled={viewMode || AddchargeId?.listOfSellerChargesIds?.length !== 0 || showViewModalCharge}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Seller Chestage Allowance</label>
                      <input
                        type="number"
                        className="form-control"
                        value={
                          editingCharge?.sellerChestageAllowance ||
                          sellerChestageAllowance
                        }
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              sellerChestageAllowance: e.target.value,
                            })
                            : setsellerChestageAllowance(e.target.value))
                        }
                        disabled={viewMode || AddchargeId?.listOfSellerChargesIds?.length !== 0}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>SPTF Recovery</label>
                      <input
                        type="number"
                        className="form-control"
                        value={editingCharge?.sptfRecovery || sptfRecovery}
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              sptfRecovery: e.target.value,
                            })
                            : setsptfRecovery(e.target.value))
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Damage Claims</label>
                      <input
                        type="number"
                        className="form-control"
                        value={editingCharge?.damageClaims || damageClaims}
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              damageClaims: e.target.value,
                            })
                            : setdamageClaims(e.target.value))
                        }
                        disabled={viewMode || AddchargeId?.listOfSellerChargesIds?.length !== 0}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Withdrawn Charges</label>
                      <input
                        type="number"
                        className="form-control"
                        value={
                          editingCharge?.withdrawnCharges || withdrawnCharges
                        }
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              withdrawnCharges: e.target.value,
                            })
                            : setwithdrawnCharges(e.target.value))
                        }
                        disabled={viewMode || AddchargeId?.listOfSellerChargesIds?.length !== 0 || showViewModalCharge}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Withdrawn SGST</label>
                      <input
                        type="number"
                        className="form-control"
                        value={showmodalCharge ? (editingCharge?.withdrawnSGST) || withdrawnSGST : AddchargeId?.withdrawnSGST}
                        onChange={handleSGSTChange}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Withdrawn CGST</label>
                      <input
                        type="number"
                        className="form-control"
                        value={showmodalCharge ? (editingCharge?.withdrawnCGST) || withdrawnCGST : AddchargeId?.withdrawnCGST}
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              withdrawnCGST: e.target.value,
                            })
                            : setwithdrawnCGST(e.target.value))
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Withdrawn IGST</label>
                      <input
                        type="number"
                        className="form-control"
                        value={showmodalCharge ? editingCharge?.withdrawnIGST || withdrawnIGST : AddchargeId?.withdrawnIGST}
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              withdrawnIGST: e.target.value,
                            })
                            : setwithdrawnIGST(e.target.value))
                        }
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Freight Charges</label>
                      <input
                        type="number"
                        className="form-control"
                        value={editingCharge?.freightCharges || freightCharges}
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              freightCharges: e.target.value,
                            })
                            : setfreightCharges(e.target.value))
                        }
                        disabled={viewMode || AddchargeId?.listOfSellerChargesIds?.length !== 0 || showViewModalCharge}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Remarks</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editingCharge?.remarks || remarks}
                        onChange={(e) =>
                          !viewMode &&
                          (editingCharge
                            ? seteditingCharge({
                              ...editingCharge,
                              remarks: e.target.value,
                            })
                            : setremarks(e.target.value))
                        }
                        disabled={viewMode || showViewModalCharge}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Net Warehouse Charges.</label>
                      <input
                        className="form-control"
                        value={totCharge}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 text-center charges-table-header modal-title">
                    Breakup of Calculation
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Gross Tea Value Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={grossTeaValue}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Auctioneer Invoice Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={auctioneerToSellerInvoiceAmount.toFixed(2)}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Teaboard Invoice Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={tboardToSellerInvoiceAmount}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Total Charges (Auctioneer and Warehouse)</label>
                      <input
                        type="number"
                        className="form-control"
                        value={total}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="FormGroup">
                      <label>Seller Net Proceeds</label>
                      <input
                        type="number"
                        className="form-control"
                        value={netAmount}
                        disabled
                      />
                    </div>
                  </div>
                  {/* <table className="table">
                    <thead>
                      
                      <tr>
                        <th>Gross Tea Value Amount</th>
                        <th>Auctioneer Invoice Amount</th>
                        <th>Teaboard Invoice Amount</th>
                        <th>Total Charges (Auctioneer and Warehouse)</th>
                        <th>Seller Net Proceeds</th>
                      </tr>
                    </thead>
                    <tr>
                      <td>{grossTeaValue}</td>
                      <td>{auctioneerToSellerInvoiceAmount}</td>
                      <td>{tboardToSellerInvoiceAmount}</td>
                      <td>{total}</td>
                      <td>{netAmount}</td>
                    </tr>
                  </table> */}

                  {ChargebyIddata == null ||
                    (ChargebyIddata.cstatus !== 2 && ChargebyIddata !== null && !showViewModalCharge) ? (
                    <div className="col-md-12">
                      <div className="BtnGroup">
                        {modalRight?.some((ele) => ele === "69") && (
                          <button
                            className="SubmitBtn"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default form submission behavior
                              callApi(e, 2); // Pass event object and button value
                            }}
                            disabled={buttonDisabled}
                          >
                            Submit
                          </button>
                        )}
                        {modalRight?.some((ele) => ele === "65") && (
                          <button
                            className="SubmitBtn"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default form submission behavior
                              callApi(e, 1); // Pass event object and button value
                            }}
                            disabled={buttonDisabled}
                          >
                            Save
                          </button>
                        )}

                        <button className="Clear" onClick={handleClear}>
                          Clear
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : ""}



      <Modal
        show={confirmationModalVisible}
        onHide={() => handleConfirm(false)}
      >
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to Invoicegenrate?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleConfirm(false)}>
            No
          </Button>
          <Button variant="primary" onClick={() => handleConfirm(true)}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {isModalOpen && (
        <div>
          <Modal
            show={isModalOpen}
            onHide={handleCloseModal}
            size="xl"
            centered
          >
            <Modal.Header>
              <Modal.Title>Upload Invoice Details</Modal.Title>
              <i
                className="fa fa-times CloseModal"
                onClick={handleCloseModal}
              ></i>
            </Modal.Header>
            <Modal.Body>
              <div className="col-md-12">
                <UploadZip
                  onFileSelect={handleFileUpload}
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  uploadDocumentError={uploadDocumentError}
                  inputId="sellerTaxInvoice"
                />
              </div>
              {uploadDocumentError && (
                <div className="error-message">{uploadDocumentError}</div>
              )}
              <div>
                <button className="SubmitBtn" onClick={handleUploadDocument}>
                  Upload
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}

export default SellerTaxInvoice;
